<template>
  <section class="faq">
    <!--头部开始-->
    <v-login-info>
      <a slot="goBack" class="left clearfix" href="javascript: void(0)" @click="goBackFn">
        <i class="icon-left-arrow"></i>
      </a>
    </v-login-info>
    <!--头部结束-->

    <div class="faq-content">
      <div class="faq-left">
        <v-faq-left></v-faq-left>
      </div>

      <div class="faq-right">
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  import faqLeft from 'components/faqLeft/faqLeft'
  import faqNew from 'views/faqNew/faqNew'
  export default {
    name: 'faq',
    methods: {
      goBackFn () {
        this.$router.push({path: '/home'})
      }
    },
    components: {
      'v-login-info': loginInfo,
      'v-faq-new': faqNew,
      'v-faq-left': faqLeft
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "faq.styl";
</style>



// WEBPACK FOOTER //
// src/views/faq/faq.vue